import { ActivatedRoute, RouterModule } from '@angular/router';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';

@Component({
  selector: 'app-promoted-ads',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    NG_ICON_DIRECTIVES
  ],
  templateUrl: './promoted-ads.component.html',
  styleUrls: ['./promoted-ads.component.scss']
})
export class PromotedAdsComponent implements OnInit, OnChanges {
  @Input() widgetDesc: string;
  @Input() suggestion: any;
  @Input() inputData: any;
  @Input() page: any;
  headerTitle: string = 'Promoted Ads';
  constructor(private a_route: ActivatedRoute) { }

  ngOnChanges(changes: SimpleChanges): void {
    // Handle widgetDesc changes for NgComponentOutlet compatibility
    if (changes.widgetDesc && changes.widgetDesc.currentValue) {
      this.headerTitle = changes.widgetDesc.currentValue;
    }
  }

  ngOnInit() {
    // Only set headerTitle if widgetDesc is provided (ngOnChanges handles dynamic updates)
    if (this.widgetDesc) {
      this.headerTitle = this.widgetDesc;
    }

    this.a_route.queryParams.subscribe((res) => {
      if(res.master && res.master!="NETWORK" && res.master!="TEAM" && res.menu!=null &&res.menu!=undefined){
       this.headerTitle=res.menu;
      }
   })
  }

}
